import { Controller } from "@hotwired/stimulus"

// Calls globally available actionjs function on a single node. The element is passed as parameter
// If a function with endfix _cleanup is defined, it will be called in the case of disconnect
export default class ActionJsSnippetController extends Controller {
  static values = {
    action: String
  };

  connect() {
    let action = this.actionValue.split('.');

    if (typeof ActionJS[action[0]] === 'object' && typeof ActionJS[action[0]][action[1]] === 'function') {
        ActionJS[action[0]][action[1]](this.element);
    }
  }

  disconnect() {
    if (typeof ActionJS[action[0]] === 'object' && typeof ActionJS[action[0]][`${action[1]}_cleanup`] === 'function') {
      ActionJS[action[0]][`${action[1]}_cleanup`](this.element);
    }
  }
}

